/**
 * RFC 4122 v4 UUID, or null when no cryptographic randomness exists.
 * Prefers crypto.randomUUID; falls back to crypto.getRandomValues (universal
 * in every browser/runtime we serve). There is deliberately NO weak-PRNG
 * tier: the share-telemetry server validates these ids against the canonical
 * UUID grammar, and a null simply degrades gracefully (pageviewId omitted →
 * server-side IP-window dedupe; attribution attempt skipped) — correct
 * behavior for a hypothetical no-crypto client, without shipping
 * Math.random-derived identifiers.
 */
export function randomUuid() {
  const c = globalThis.crypto;
  if (c?.randomUUID) return c.randomUUID();
  if (c?.getRandomValues) {
    const bytes = c.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
    const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0"));
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
      .slice(6, 8)
      .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
  }
  return null;
}
